import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { IonReactRouter } from "@ionic/react-router";

// Render the React app
ReactDOM.render(
  <React.StrictMode>
    <IonReactRouter>
      <App />
    </IonReactRouter>
  </React.StrictMode>,
  document.getElementById("root")
);

// Measure performance in the app
reportWebVitals();